import { createSelector } from 'reselect';

import { EContactStatuses } from '@r1-frontend/api-domru/api-profile/v2/info/all/dto/ResponseDto';

import { TState } from '~/src/store';

export const confirmedEmails = createSelector(
    (state: TState) => state.auth.clientContacts?.email,
    emails => {
        return emails?.length
            ? emails
                .filter(_email => _email.status === EContactStatuses.confirmed && !!_email.value)
                .map(_email => ({ value: _email.id, label: _email.value }))
            : [];
    },
);
